import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const HierarchySaveDigitalMediaModal = ({
  isOpen,
  toggle,
  onSubmitHierarchy,
  tab,
  onSubmit
}) => {
  return (
    <Modal
      className="modal-event-hierarchy modal-md"
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>
        <div>
          Would you like to save this content across the entire program hierarchy?
        </div>
      </ModalHeader>

      <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
        <Button
          outline
          className="btn btn-primary btn-sm"
          onClick={() => {
            toggle();
            tab == '1' && onSubmit();
          }}
          color="#ffffff"
        >
          No, only save to this program
        </Button>

        <Button
          outline
          className="btn btn-primary btn-sm"
          onClick={() => {
            toggle();
            onSubmitHierarchy();
          }}
          color="#ffffff"
          style={{ float: "left" }}
        >
          Yes, save to Hierarchy
        </Button>

        <Button
          outline
          color="primary"
          className="btn btn-sm"
          onClick={toggle}
          style={{ float: "right" }}
        >
          Cancel
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default HierarchySaveDigitalMediaModal;
